import { createFileRoute } from "@tanstack/react-router";
import { GiftCardProductDetail } from "@/components/gift-cards/product-detail";
import { GiftCardError, GiftCardSkeleton } from "@/components/gift-cards/shared";
import { giftCardDetailQuery, giftCardMeta } from "@/lib/gift-cards";

export const Route = createFileRoute("/_site/gift-cards/$brand/$id")({
  loader: ({ context, params }) => context.queryClient.ensureQueryData(giftCardDetailQuery(params.id)),
  head: ({ loaderData }) => giftCardMeta(loaderData?.data),
  pendingComponent: GiftCardDetailPending,
  errorComponent: GiftCardError,
  notFoundComponent: GiftCardError,
  component: GiftCardDetail,
});
function GiftCardDetailPending() { return <GiftCardSkeleton detail />; }
function GiftCardDetail() {
  const { id } = Route.useParams();
  return <GiftCardProductDetail id={id} />;
}
